import { withoutIndex } from '../../../utils';

export const reducer = (state, action) => {
  switch (action.type) {
    case 'addBeacon':
      return [...state, { event: action.event, url: '' }];
    case 'removeBeacon':
      return withoutIndex(state, action.index);
    case 'updateBeacon':
      return [
        ...state.slice(0, action.index),
        { ...state[action.index], ...action.payload },
        ...state.slice(action.index + 1)
      ];
    case 'assignVendor':
      return [
        ...state.slice(0, action.index),
        { ...state[action.index], vendorId: action.vendorId },
        ...state.slice(action.index + 1)
      ];
    case 'setRequired':
      return state.map(c => {
        c.required = action.payload.required;
        return c;
      });
    default:
      return state;
  }
};
